import { Card, CardContent, CardHeader, CardTitle } from '~/components/ui/card';
import { AddPaymentMethodButton } from './AddPaymentMethodButton';

interface PaymentMethodData {
  summary?: string | null;
  methodType?: string | null;
  last4?: string | null;
  autopayEnabled?: boolean | null;
}

interface ParentPaymentMethodCardProps {
  paymentMethod?: PaymentMethodData | null;
  familyEnrollmentId: string;
  onRedirect?: (url: string) => void;
  // Set when an admin is viewing this family's portal; hides guardian actions.
  readOnly?: boolean;
}

// Two things a parent keeps straight (ruling, 2026-09-12): the auto-pay method,
// which automatic invoices charge, and the saved methods they choose from when
// they pay an invoice themselves. This card is the first one.
export const AUTO_PAY_EXPLANATION =
  'Automatic invoices are charged to this method. When you pay an invoice yourself, you choose which saved method to use.';

export function ParentPaymentMethodCard({ paymentMethod, familyEnrollmentId, onRedirect, readOnly }: ParentPaymentMethodCardProps) {
  return (
    <Card>
      <CardHeader><CardTitle>Auto-pay method</CardTitle></CardHeader>
      <CardContent className="space-y-4">
        <p className="text-sm">
          {paymentMethod?.summary
            ? paymentMethod.summary
            : <span className="text-muted-foreground">None yet</span>}
        </p>
        <p className="text-sm text-muted-foreground">{AUTO_PAY_EXPLANATION}</p>
        {readOnly ? null : (
          <AddPaymentMethodButton familyEnrollmentId={familyEnrollmentId} onRedirect={onRedirect} />
        )}
      </CardContent>
    </Card>
  );
}
